<template>
    <div>
        <div class="mark arrow2 col999" @click="onPopup(1)" v-if="couponsList.length">
            优惠券
            <div class="item f24 coupon">
                <span
                    v-for="item in couponsList"
                    :key='item.id'
                    v-text="item.couponType === 1 ? '满' + item.reachAmount + '减' + item.couponValue : '现金券' + item.couponValue + '元'">
                </span>
            </div>
        </div>
        <div class="mark arrow2 col999" @click="onPopup(2)" v-if="activityList.length">
            促销
            <div class="item">
                <span v-text="activityName"></span>
            </div>
        </div>
        <ConpouPopup v-if="couponsList.length" :couponsList='couponsList' :visible.sync='couponPopup' @onDraw='onDraw' />
        <ActivityPopup v-if="activityList.length" :activityList='activityList' :visible.sync='activityPopup' />
    </div>
</template>

<script>
import ConpouPopup from './conpouPopup'
import ActivityPopup from './activityPopup'
import { Toast } from 'vant'
import { getDraw, getActivityList } from '../../../api/activity'
export default {
    components: {
        ConpouPopup,
        ActivityPopup
    },
    props: {
        servicesData: {
            type: Object,
            defalut: {}
        }
    },
    data () {
        return {
            couponPopup: false,
            activityPopup: false,
            activityName: '',
            userInfo: {},
            activityList: [],
            couponsList: []
        }
    },
    methods: {
        onPopup (type) {
            if (type === 1) {
                this.couponPopup = !this.couponPopup
            } else {
                this.activityPopup = !this.activityPopup
            }
        },
        async onDraw (item) {
            await getDraw({
                memberCode: this.userInfo.companyCode,
                couponCode: item.couponCode,
                drawUserId: this.userInfo.id
            })
            Toast('领取成功!')
            this.getActivity()
        },
        async getActivity () {
            let nameArr = []
            const { data } = await getActivityList({
                categoryId: this.servicesData.categoryId,
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                productId: this.servicesData.goodsId
            })
            this.activityList = data.activities || []
            this.couponsList = data.coupons || []
            if (!data.activities) {
                return false
            }
            data.activities.forEach((item, index) => {
                if (item.activityType === 1) {
                    if (item.activityRule === 1) {
                        nameArr.push(this.getTitle(item.joinType) + '满' + item.reachValue + '元减' + item.activityValue + '元')
                    } else {
                        nameArr.push(this.getTitle(item.joinType) + '每满' + item.reachValue + '元减' + item.activityValue + '元')
                    }
                } else {
                    nameArr.push(this.getTitle(item.joinType) + '全部' + item.reachValue + '件打' + item.activityValue / 10 + '折')
                }
            })
            this.activityName = nameArr.join(',')
        },
        // 判断显示
        getTitle (type) {
            if (type === 1) {
                return '全场参加'
            } else if (type === 2) {
                return '指定类目'
            } else {
                return '指定商品'
            }
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.getActivity()
    }
}
</script>

<style lang="scss" scoped>
    .mark {
        font-size: 28px;
        position: relative;
        background-color: #ffffff;
        height: 96px;
        line-height: 96px;
        padding: 0 32px;
        &:not(:last-child)::before {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            border-bottom: 2px solid rgba(209,209,214,1);
            transform: scaleY(0.5);
        }
        span {
            color: #000;
        }
        .item {
            float: right;
            margin-right: 40px;
            width: 480px;
            color: #333333;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            &.coupon {
                span {
                    position: relative;
                    height: 44px;
                    line-height: 44px;
                    display: inline-block;
                    background: #fff1ec;
                    padding: 0 12px;
                    margin-right: 16px;
                    border-top: 1px solid #ff7a45;
                    border-bottom: 1px solid #ff7a45;
                    color: #ff4d4f;
                    &::before {
                        position: absolute;
                        content: '';
                        left: 0;
                        top: 0;
                        bottom: 0;
                        width: 5px;
                        height: 44px;
                        background: url('../../../../../assets/img/b2b/conponBg_01.png')
                            no-repeat;
                        background-size: 100%;
                    }
                    &::after {
                        position: absolute;
                        content: '';
                        right: 0;
                        top: 0;
                        bottom: 0;
                        width: 5px;
                        height: 44px;
                        background: url('../../../../../assets/img/b2b/conponBg_02.png')
                            no-repeat;
                        background-size: 100%;
                    }
                }
            }
        }
    }
</style>